// Header.jsx
import React from "react";

const Header = ({ onOpenReport }) => {
  return (
    <header className="flex justify-between items-center p-4 bg-gray-800 text-white">
      <h1 className="text-xl font-bold">Daily Reports</h1>
      <div className="space-x-4">
        <button
          onClick={onOpenReport}
          className="bg-blue-500 px-4 py-2 rounded hover:bg-blue-600"
        >
          New Report
        </button>
      </div>
    </header>
  );
};

export default Header;
